import React from 'react'
import {fmN, fmP} from '../../helpers/format'

// missing_output dùng chung cho mọi tab (Report/Process: số đóng thùng; Material/Print/Press: số in; Sewing: số giao may; Cut: số lượt cắt),
// nên phải lấy đúng tên mẫu số của tab đang xem (outputBasis, backend trả theo config.output_basis) thay vì ghi cứng "số lượng in".
const WARNING_TEXT = {
    missing_output: (w, outputBasis) => `${fmN(w.batches)} lô (${fmP(w.ratio)}) thiếu ${outputBasis || 'số liệu mẫu số'} nên bị loại khỏi mẫu số — mẫu số đang thiếu.`,
    no_output_for_source: () => 'Đang lọc theo nguồn hàng: số đóng thùng không mang thông tin nguồn hàng nên không tính được tỉ lệ.',
    cut_output_fallback: (w) => `${fmN(w.batches)} lô không có số lượng lượt cắt, mẫu số lấy số item của lô.`,
}

const NotesBlock = ({notes = [], warnings = [], pendingSources = [], outputBasis}) => {
    if (!notes.length && !warnings.length && !pendingSources.length) return null

    return (
        <div className="note">
            <b>Cách tính:</b>
            <ul>
                {notes.map(note => <li key={note}>{note}</li>)}
                {warnings.map(w => WARNING_TEXT[w.code] ? <li key={w.code}><b>⚠ {WARNING_TEXT[w.code](w, outputBasis)}</b></li> : null)}
                {!!pendingSources.length && <li><b>Nguồn hàng chờ xác nhận:</b> {pendingSources.join(', ')}</li>}
            </ul>
        </div>
    )
}

export default NotesBlock
